import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';
import * as paths from 'Paths';


const LoginRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/auth/login" */
    'routes/Auth/LoginRoute'
  )
));

const OAuthLoginRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/auth/oauth-login" */
    'routes/Auth/OAuthLoginRoute'
  )
));

const LogoutRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/auth/logout" */
    'routes/Auth/LogoutRoute'
  )
));

const RegisterRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/auth/register" */
    'routes/Auth/Register/RegisterRoute'
  )
));

const RegisterCompleteRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/auth/register-complete" */
    'routes/Auth/Register/RegisterCompleteRoute'
  )
));

const RegisterCompleteVerifyRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/auth/register-complete-verify" */
    'routes/Auth/Register/RegisterCompleteVerifyRoute'
  )
));

const ResetPasswordRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/auth/reset-password" */
    'routes/Auth/Password/ResetPasswordRoute'
  )
));

const ResetPasswordDoneRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/auth/reset-password-done */
    'routes/Auth/Password/ResetPasswordDoneRoute'
  )
));

const SetNewPasswordRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/auth/set-new-password" */
    'routes/Auth/Password/SetNewPasswordRoute'
  )
));

const SetNewPasswordCompleteRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/auth/set-new-password-complete" */
    'routes/Auth/Password/SetNewPasswordCompleteRoute'
  )
));

const SetPasswordAddedUserRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/auth/set-password-added-user" */
    'routes/Auth/Password/SetPasswordAddedUserRoute'
  )
));

const SetPasswordAddedUserCompleteRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/auth/set-password-added-user-complete" */
    'routes/Auth/Password/SetPasswordAddedUserCompleteRoute'
  )
));

const UnverifiedRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/auth/unverified" */
    'routes/Auth/UnverifiedRoute'
  )
));


const getAuthRoutes = () => {
  return [
    {path: paths.getPathLogin(), component: LoginRoute},
    {path: paths.getPathOAuthLogin(), component: OAuthLoginRoute},
    {path: paths.getPathLogout(), component: LogoutRoute},

    {path: paths.getPathRegister(), component: RegisterRoute},
    {path: paths.getPathRegisterComplete(), component: RegisterCompleteRoute},
    {path: paths.getPathRegisterCompleteVerify(), component: RegisterCompleteVerifyRoute},

    {path: paths.getPathResetPassword(), component: ResetPasswordRoute},
    {path: paths.getPathResetPasswordDone(), component: ResetPasswordDoneRoute},
    {path: paths.getPathSetNewPassword(":uidb64", ":token"), component: SetNewPasswordRoute},
    {path: paths.getPathSetNewPasswordComplete(), component: SetNewPasswordCompleteRoute},
    {path: paths.getPathSetPasswordAddedUser(":key"), component: SetPasswordAddedUserRoute},
    {path: paths.getPathSetPasswordAddedUserComplete(), component: SetPasswordAddedUserCompleteRoute},

    {path: paths.getPathUnverified(), component: UnverifiedRoute},
  ]
}


export { getAuthRoutes };
